import React, { useEffect, useRef, useState } from "react";
import Heading from "../../component/Heading";
import AlertBox from "../../component/AlertBox";
import Loading from "../../component/Loading";
import { axiosInstance } from "../../constant";
import {
  FormControlLabel,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import ButtonCompo from "../../component/ButtonCompo";
import { Link } from "react-router-dom";
import { IoMdCloudDownload } from "react-icons/io";
import { IoMdRefresh } from "react-icons/io";
import { DatePicker } from "@mui/x-date-pickers";
import DialogBox from "../../component/DialogBox";
import { FaCheckCircle } from "react-icons/fa";

function STReport() {
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(undefined);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [reload, setReload] = useState(false);
  const [orderData, setOrderData] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState(undefined);
  const [endaDate, setEndDate] = useState(undefined);
  const [reportLink, setReportLink] = useState("");
  const dialogBoxRef = useRef(null);

  // get orders
  async function getOrders() {
    try {
      setLoading(true);
      const data = {
        startDate: startDate,
        endDate: endaDate,
        delivaryStatus: keyword,
        search: search,
      };
      const res = await axiosInstance.post(
        `/api/v1/report/get/order/history`,
        data
      );
      const rawData = res.data?.data;
      console.log(res.data?.data);
      setOrderData(rawData);
    } catch (error) {
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  // generate daily report
  async function generateDailyReport() {
    try {
      setLoading(true);
      const data = {
        data: orderData,
      };
      const res = await axiosInstance.post(
        `/api/v1/report/generate/daily`,
        data
      );
      setReportLink(res.data?.data?.data);
      if (dialogBoxRef.current) {
        dialogBoxRef.current.handleOpen();
      }
    } catch (error) {
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getOrders();
  }, [reload]);

  function onSearch() {
    setReload((prev) => !prev);
  }

  function onReload() {
    setReload((prev) => !prev);
    setKeyword("");
    setSearch("");
    setStartDate(undefined);
    setEndDate(undefined);
  }

  return (
    <>
      {loading && <Loading />}
      <div className="w-full flex justify-center items-center">
        {success !== undefined && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <DialogBox
          ref={dialogBoxRef}
          actionButton={
            <Link to={reportLink} target="_blank">
              <ButtonCompo>View Report</ButtonCompo>
            </Link>
          }
        >
          <div className="flex flex-col justify-center items-center gap-3">
            <FaCheckCircle size={40} className="text-green-500" />
            <p className="text-slate-500">
              Report has been generated successfully
            </p>
          </div>
        </DialogBox>
        <div className="w-[90vw]">
          <Heading>Reports</Heading>
          <div className="w-full flex justify-between gap-3 mt-[2rem]">
            <div className="flex justify-center items-center">
              <RadioGroup
                onChange={(event) => setKeyword(event?.target?.value)}
                value={keyword}
              >
                <div className="flex flex-wrap">
                  <FormControlLabel
                    value=""
                    control={<Radio />}
                    label="All Orders"
                  />
                  <FormControlLabel
                    value="Confirmed"
                    control={<Radio />}
                    label="Order Confirmed"
                  />
                  <FormControlLabel
                    value="Prepeared"
                    control={<Radio />}
                    label="Order Prepeared"
                  />
                  <FormControlLabel
                    value="Dispatched"
                    control={<Radio />}
                    label="Order Dispatched"
                  />
                  <FormControlLabel
                    value="Out for Delivary"
                    control={<Radio />}
                    label="Out For Delivery"
                  />
                  <FormControlLabel
                    value="Delivered"
                    control={<Radio />}
                    label="Order Delivered"
                  />
                </div>
              </RadioGroup>
            </div>
            <div className="flex items-center gap-2">
              <ButtonCompo onClick={onReload}>
                <IoMdRefresh size={25} />
              </ButtonCompo>
              <section className="flex gap-3">
                <TextField
                  size="small"
                  placeholder="Order ID, Name, Phone No"
                  onChange={(event) => setSearch(event?.target?.value)}
                />
                <ButtonCompo variant={"primary"} onClick={onSearch}>
                  Search
                </ButtonCompo>
              </section>
            </div>
          </div>
          <div className="w-full flex justify-between gap-3 mt-[1rem]">
            <div className="flex items-center gap-5">
              <DatePicker
                label="From"
                onChange={(value) => setStartDate(value)}
              />
              <DatePicker label="To" onChange={(value) => setEndDate(value)} />
            </div>
            <div className="flex gap-5 items-center">
              <ButtonCompo
                variant={"primary"}
                startIcon={<IoMdCloudDownload />}
                href="/staff/products/reports"
              >
                Product Report
              </ButtonCompo>
              <ButtonCompo
                variant={"primary"}
                startIcon={<IoMdCloudDownload />}
                onClick={generateDailyReport}
              >
                Order Report
              </ButtonCompo>
            </div>
          </div>
          <div className="mt-5">
            <Table>
              <TableHead>
                <TableRow className="bg-[#FF8000]">
                  <TableCell className="!text-white !font-semibold !text-center">
                    Serial No.
                  </TableCell>
                  <TableCell className="!text-white !font-semibold !text-center">
                    Order ID
                  </TableCell>
                  <TableCell className="!text-white !font-semibold !text-center">
                    Total Products
                  </TableCell>
                  <TableCell className="!text-white !font-semibold !text-center">
                    Bill Amount
                  </TableCell>
                  <TableCell className="!text-white !font-semibold !text-center">
                    Date
                  </TableCell>
                  <TableCell className="!text-white !font-semibold !text-center">
                    Payment Status
                  </TableCell>
                  <TableCell className="!text-white !font-semibold !text-center">
                    Invoice
                  </TableCell>
                  <TableCell className="!text-white !font-semibold !text-center">
                    More
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {orderData?.map((order, i) => (
                  <TableRow className="bg-white">
                    <TableCell className="!text-slate-800 !text-center">
                      {i + 1}
                    </TableCell>
                    <TableCell className="!text-slate-800 !text-center">
                      <span className="bg-orange-500 px-3 py-1 rounded-full text-white font-semibold">
                        {order?.orderNumber}
                      </span>
                    </TableCell>
                    <TableCell className="!text-slate-800 !text-center">
                      {order?.products?.length}
                    </TableCell>
                    <TableCell className="!text-slate-800 !text-center">
                      ₹{order?.totalPrice}
                    </TableCell>
                    <TableCell className="!text-slate-800 !text-center">
                      {new Date(order?.date).toLocaleDateString()}
                    </TableCell>
                    <TableCell className="!text-slate-800 !text-center">
                      {order?.paymentStatus === "success" ? (
                        <span className="text-green-700 px-3 py-1 rounded-full bg-green-200/50 font-medium">
                          Success
                        </span>
                      ) : order?.paymentStatus === "Due" ? (
                        <span className="text-yellow-700 px-3 py-1 rounded-full bg-yellow-200/50 font-medium">
                          Awaiting
                        </span>
                      ) : (
                        <span className="text-red-700 px-3 py-1 rounded-full bg-red-200/50 font-medium">
                          Failed
                        </span>
                      )}
                    </TableCell>
                    <TableCell className="!text-slate-800 !text-center">
                      {order?.invoice === undefined || order?.length === 0 ? (
                        <ButtonCompo
                          disabled
                          className="!bg-[#FF8000] opacity-50 !text-white !px-7 !font-semibold"
                        >
                          Invoice
                        </ButtonCompo>
                      ) : (
                        <Link to={order?.invoice} target="_blank">
                          <ButtonCompo className="!bg-[#FF8000] !text-white !px-7 !font-semibold">
                            Invoice
                          </ButtonCompo>
                        </Link>
                      )}
                    </TableCell>
                    <TableCell className="!text-slate-800 !text-center">
                      <Link to={`/staff/order/get/${order?._id}`}>
                        <ButtonCompo>More</ButtonCompo>
                      </Link>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </div>
      </div>
    </>
  );
}

export default STReport;
